import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ZenriseDebtResponse } from '@pedix-workspace/utils';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ReactivateService {
  private http = inject(HttpClient);
  
  constructor() {}

  getDebt(subscriptionId: string) {
    return this.http.get<ZenriseDebtResponse>(
      `${environment.apiUrl}/payments/debt/${subscriptionId}`,
    );
  }
}
